import {FormGroup} from '@angular/forms';
import {FieldUiDataObj} from '../../../../../generated/generated-core.model';

export class MxFormAndFieldsObj {

    private _form: FormGroup;
    private _fields: Array<FieldUiDataObj>;

    constructor(form: FormGroup, fields: Array<FieldUiDataObj>) {
        this._form = form;
        this._fields = fields;
    }

    get form(): FormGroup {
        return this._form;
    }

    get fields(): Array<FieldUiDataObj> {
        return this._fields;
    }
}
